import { createSlice } from '@reduxjs/toolkit';
import {
  BranchRequest,
  BranchResponse,
  GetKYDataApproveBySiteManageResponse,
  GetSiteStatusLockedResponse,
  GetStatusKyResponse,
  User,
} from 'types';
import {
  getBranchs,
  getKYDataApproveBySiteManage,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  getKYDataApproveGroupBySiteManage,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  getLockStatus,
  getStatusKy,
  getUserProfile,
  selectBranch,
} from './thunk';

export interface InitialState {
  user: User | null;
  notifyCount: number;
  LockStatusData: GetSiteStatusLockedResponse | null;
  KYDataApproveBySiteManageDate: GetKYDataApproveBySiteManageResponse | null;
  StatusKyData: GetStatusKyResponse | null;
  LoadingLockStatusData: boolean;
  LoadingKYDataApproveBySiteManageDate: boolean;
  LoadingStatusKyData: boolean;
  branchs: BranchResponse['branchs'];
  branchSelected: BranchRequest | null;
}

const initialState: InitialState = {
  user: null,
  notifyCount: 88,
  LockStatusData: null,
  KYDataApproveBySiteManageDate: null,
  StatusKyData: null,
  LoadingKYDataApproveBySiteManageDate: false,
  LoadingLockStatusData: false,
  LoadingStatusKyData: false,
  branchs: [],
  branchSelected: null,
};

export const layoutSlice = createSlice({
  name: 'layout-container',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // branchs
    builder.addCase(getBranchs.fulfilled, (state, { payload }) => {
      state.branchs = payload.branchs;
    });
    builder.addCase(selectBranch.fulfilled, (state, { payload }) => {
      state.branchSelected = payload;
    });

    builder.addCase(getUserProfile.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    // getLockStatus
    builder.addCase(getLockStatus.pending, (state) => {
      state.LoadingLockStatusData = true;
      // state.LockStatusData = null;
    });
    builder.addCase(getLockStatus.fulfilled, (state, action) => {
      state.LockStatusData = action.payload;
      state.LoadingLockStatusData = false;
    });
    builder.addCase(getLockStatus.rejected, (state) => {
      state.LoadingLockStatusData = false;
      state.LockStatusData = null;
    });
    // getKYDataApproveBySiteManage
    builder.addCase(getKYDataApproveBySiteManage.pending, (state) => {
      state.LoadingKYDataApproveBySiteManageDate = true;
      state.KYDataApproveBySiteManageDate = null;
    });
    builder.addCase(getKYDataApproveBySiteManage.fulfilled, (state, action) => {
      state.KYDataApproveBySiteManageDate = action.payload;
      state.LoadingKYDataApproveBySiteManageDate = false;
    });
    builder.addCase(getKYDataApproveBySiteManage.rejected, (state) => {
      state.LoadingKYDataApproveBySiteManageDate = false;
      state.KYDataApproveBySiteManageDate = null;
    });
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // getKYDataApproveGroupBySiteManage
    builder.addCase(getKYDataApproveGroupBySiteManage.pending, (state) => {
      state.LoadingKYDataApproveBySiteManageDate = true;
      state.KYDataApproveBySiteManageDate = null;
    });
    builder.addCase(getKYDataApproveGroupBySiteManage.fulfilled, (state, action) => {
      state.KYDataApproveBySiteManageDate = action.payload;
      state.LoadingKYDataApproveBySiteManageDate = false;
    });
    builder.addCase(getKYDataApproveGroupBySiteManage.rejected, (state) => {
      state.LoadingKYDataApproveBySiteManageDate = false;
      state.KYDataApproveBySiteManageDate = null;
    });
    // 2025/02/25 FJ 3月分反映分 NO32 start
    // getStatusKy
    builder.addCase(getStatusKy.pending, (state) => {
      state.LoadingStatusKyData = true;
      state.StatusKyData = null;
    });
    builder.addCase(getStatusKy.fulfilled, (state, action) => {
      state.StatusKyData = action.payload;
      state.LoadingStatusKyData = false;
    });
    builder.addCase(getStatusKy.rejected, (state) => {
      state.LoadingStatusKyData = false;
      state.StatusKyData = null;
    });
  },
});
// export const {} = layoutSlice.actions;

export default layoutSlice.reducer;
